export default {"src":"/_next/static/media/首页.49660325.svg","height":19,"width":67};